/*
//-------------------------------------------------------
//   Copyright (c) 2019 Templa Computer Systems Ltd
//
//   App:        EmployeePortal.UI
//   Object:     ItemList
//   Details:    Item list compoment
//
// Log      Date   By  Scan Description
// -----  -------- --- ---- ------------------------------
// 102715 16/08/19 JC  M01  Added Contacts handling
// 103782 10/12/19 JC  M02  Added MyTraining
// 105066 06/01/20 JC  M03  Added font awesome
// 103839 06/04/20 JC  M04  React upgrade
// WI3713 24/01/24 JC  M05JC    Expanded documents for data forms, moved expanded to item store
//-------------------------------------------------------
*/
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { itemActions } from '../store/Items';
import Loading from './Loading';
import NoItems from './NoItems';
//M03 import { Glyphicon } from 'react-bootstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //M03
import AlertPanel from './AlertPanel';
import ItemTypeControl from './ItemTypeControl';
import Item from './Item';
import './css/ItemsList.css';
import { redirectControllerActions } from '../store/RedirectController'; //M05JC
import { red } from '@material-ui/core/colors';

class ItemsList extends Component {
	constructor(props) {
		super(props);

		this.handleItemTypeSelect = this.handleItemTypeSelect.bind(this);
		this.handlePrev = this.handlePrev.bind(this);
		this.handleNext = this.handleNext.bind(this);
		this.handleFirst = this.handleFirst.bind(this);
		this.handleLast = this.handleLast.bind(this);
		this.handleMarkAsRead = this.handleMarkAsRead.bind(this);
		this.handleMarkAsUnread = this.handleMarkAsUnread.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleStartTraining = this.handleStartTraining.bind(this); //M02
        this.handleChangeTrainingQuestion = this.handleChangeTrainingQuestion.bind(this); //M02
        this.handleAnswerTrainingQuestion = this.handleAnswerTrainingQuestion.bind(this); //M02
		this.handleCompleteTraining = this.handleCompleteTraining.bind(this); //M02
		this.handleDataFormClick = this.handleDataFormClick.bind(this); //M05JC
		this.handleExpandedCollapse = this.handleExpandedCollapse.bind(this); //M05JC
	}

    //M04 componentWillMount
    componentDidMount() {
		// This method runs when the component is first added to the page
		//M05JC added expandedItemId
		this.props.getPage(this.props.page, this.props.itemCategory, this.props.itemTypeId, this.props.expandedItemId);
	}

	handleItemTypeSelect = itemTypeId => {
		this.props.getPage(this.props.page, this.props.itemCategory, itemTypeId);
	}

	handleMarkAsRead = item => {
		this.props.markAsRead(item.id, this.props.itemCategory, this.props.itemTypeId);
	}

	handleMarkAsUnread = item => {
		this.props.markAsUnread(item.id, this.props.itemCategory, this.props.itemTypeId);
	}

	handleNew = event => {
		this.props.onNewClick();
    }

    //M02 handle start training
    handleStartTraining = item => {
        this.props.startTraining(item.id, this.props.itemCategory, this.props.items);
    }

    //M02 handle change training question
    handleChangeTrainingQuestion = (item, forward) => {
        this.props.changeTrainingQuestion(item.id, this.props.itemCategory, this.props.items, forward);
    }

    //M02 handle answer training question
    handleAnswerTrainingQuestion = (item, answerIndex) => {
        this.props.answerTrainingQuestion(item.id, this.props.itemCategory, this.props.items, answerIndex);
    }

    //M02 handle complete training 
    handleCompleteTraining = item => {
        this.props.completeTraining(item.id, this.props.itemCategory, this.props.itemTypeId, this.props.items);
    }

	handlePrev = event => {
		event.preventDefault();
		const { page } = this.props;
		if (page !== undefined && page > 1) {
			this.props.getPage(page - 1, this.props.itemCategory, this.props.itemTypeId);
		}
	}

	handleNext = event => {
		event.preventDefault();
		const { page, maxPage } = this.props;
		if (page !== undefined && page < maxPage) {
			this.props.getPage(page + 1, this.props.itemCategory, this.props.itemTypeId);
		}
	}

	handleFirst = event => {
		event.preventDefault();
		const { page } = this.props;
		if (page !== undefined && page > 1) {
			this.props.getPage(1, this.props.itemCategory, this.props.itemTypeId);
		}
	}

	handleLast = event => {
		event.preventDefault();
		const { page, maxPage } = this.props;
		if (page !== undefined && page < maxPage) {
			this.props.getPage(maxPage, this.props.itemCategory, this.props.itemTypeId);
		}
	}

	//M05JC handler for data form click
	handleDataFormClick = item => {

		//build prev page args
		let prevPageArgs = {
			showHistory: this.props.showHistory,
			itemId: item.id
		}
		//and redirect page
		let redirectPage = `/dataform/${item.id}/${item.dataFormOwnerType}`;

		//and pass to redirect controller
		this.props.redirect(redirectPage, prevPageArgs);
	}

	//M05JC handler for item expand/collapse 
	handleExpandedCollapse = (item) => {
		this.props.updateIsExpanded(item.id, this.props.itemCategory, this.props.items);
	}

	render() {
		const { isLoading, items, page, maxPage, showNewButton, newButtonText } = this.props;
		const canNavigate = page !== undefined && !isLoading;
		const canPrev = canNavigate && page > 1;
		const canNext = canNavigate && page < maxPage;

		return (
			<div>
                <div className={isLoading ? "list-loading" : ""}>
                    {!this.props.simpleMode ?
                         /* M01 don't show the categories if in all simple mode */
                        <ItemTypeControl itemCategory={this.props.itemCategory} items={this.props.itemTypes} itemTypeId={this.props.itemTypeId} selectItemType={this.handleItemTypeSelect} />
                        : []}
				</div>
				{showNewButton
					? <div>
						<button className="btn btn-default" onClick={this.handleNew}>{newButtonText}</button>
					</div>
					: []}
				{this.props.error ? <AlertPanel type="danger" message={this.props.error} /> : []}

				{isLoading ? <Loading /> : []}
				{!isLoading && (items === undefined || items.length === 0)
					? <NoItems />
					: <div className={`page-table ${isLoading ? "list-loading" : ""}`}>
						{items.map(item =>
							/* pass simple mode to item */
							<Item key={item.id} item={item}
								markAsRead={this.handleMarkAsRead}
								markAsUnread={this.handleMarkAsUnread}
								simpleMode={this.props.simpleMode}
								startTraining={this.handleStartTraining} /*M02*/
								changeTrainingQuestion={this.handleChangeTrainingQuestion} /*M02*/
								answerTrainingQuestion={this.handleAnswerTrainingQuestion} /*M02*/
								completeTraining={this.handleCompleteTraining} /*M02*/
								handleDataFormClick={this.handleDataFormClick} /*M05JC*/
								handleExpandedCollapse={this.handleExpandedCollapse} /*M05JC*/
                            />
						)}
					</div>
					}

				{maxPage > 1
					? <div className={`clearfix text-center button-tray ${isLoading ? "list-loading" : ""}`}>
						<div className="button-group float-left">
                            <button className="btn btn-default" disabled={!canPrev} onClick={this.handleFirst}><FontAwesomeIcon icon="step-backward" /></button> {/* M03 */}
                            <button className="btn btn-default" disabled={!canPrev} onClick={this.handlePrev}><FontAwesomeIcon icon="chevron-left" /> Previous</button> {/* M03 */}
						</div>
						<span className="float-centre">Page {page} of {maxPage}</span>
						<div className="button-group float-right">
                            <button className="btn btn-default" disabled={!canNext} onClick={this.handleNext}>Next <FontAwesomeIcon icon="chevron-right" /></button> {/* M03 */}
                            <button className="btn btn-default" disabled={!canNext} onClick={this.handleLast}><FontAwesomeIcon icon="step-forward" /></button> {/* M03 */}
						</div>
					</div>
					: []}
			</div>
		);
	}
}

ItemsList.propTypes = {
	itemCategory: PropTypes.string,
	itemTypes: PropTypes.arrayOf(PropTypes.any),
	itemTypeId: PropTypes.number,
	items: PropTypes.arrayOf(PropTypes.any),
	maxPage: PropTypes.number,
	page: PropTypes.number,
	error: PropTypes.string,
	isLoading: PropTypes.bool,
	getPage: PropTypes.func.isRequired,

	showNewButton: PropTypes.bool,
	newButtonText: PropTypes.string,
	onNewClick: PropTypes.func
};

export default connect(
	state => state,
	dispatch => bindActionCreators({ ...itemActions, ...redirectControllerActions}, dispatch) //M05JC
)(ItemsList);
